<template>
  <div :class="setClass">
    <star-rating
      v-model="rateNumber"
      :increment="0.01"
      :max-rating="5"
      :read-only="true"
      :show-rating="showRatingFlg"
      :fixed-points="2"
      :star-size="30"
      inactive-color="#d8d8d8"
      active-color="#febb33"
      text-class="text-primary font-weight-bold font-title"
      :inline="false"
      :padding="3"
      class="col-6 my-1"
    />
    <!-- https://www.npmjs.com/package/vue-star-rating -->
    <radar-chart
      :chart-data="datacollection"
      :options="optioncollection"
      class="col-10 mx-auto"
    />
  </div>
</template>

<script>
import RadarChart from "./RadarChart.vue";
import StarRating from "vue-star-rating";
import I18n from "../i18n/i18n";
import "../i18n/ja";
import { i18n } from "../mixins/i18n";

export default {
  components: {
    RadarChart,
    StarRating
  },
  mixins: [i18n],
  props: {
    rateDetailObj: {
      type: Object,
      default() {
        return {
          a: 3,
          b: 3,
          c: 3,
          d: 3,
          e: 3
        };
      }
    },
    setClass: {
      type: String,
      default: "row"
    },
    rateNumber: {
      type: Number,
      default: 0
    },
    compareFlg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datacollection: {},
      optioncollection: {},
      showRatingFlg: true
    };
  },
  mounted() {
    this.fillData();
    if (this.rateNumber === 0) {
      this.showRatingFlg = false;
    }
  },
  methods: {
    fillData() {

      // メソッドを呼び出すことで、データのリアクティブ化に対応
      this.datacollection = {
        labels: (!this.compareFlg) ? Object.entries(this.rateDetailObj) : Object.keys(this.rateDetailObj), // [["技術・専門", "1.00"], ["法令順守", "1.00"], ...] 改行対応

        // TODO: 2つ以上のデータの比較の際は、datasetsの配列をpropsに移動させ, 親から渡す。その際はオブジェクトに含まれるrateDetailObjも不要になる。また、compareFlgをtrueにする必要あり。
        datasets: [
          {

            // レイヤー設定
            fill: true, // レイヤーの塗り潰し
            backgroundColor: "rgba(0, 123, 255, 0.5)", // レイヤーの色
            borderColor: "rgba(0, 123, 255, 1)", // レイヤー枠の色
            borderWidth: 2, // レイヤー枠の幅

            // ポイントマーカー設定
            pointStyle: "circle", // マウスが載った際のポイントの形
            pointBackgroundColor: "rgba(0, 123, 255, 1)", // ポイントの色
            pointBorderColor: "rgba(0, 123, 255, 1)", // ポイントの枠色
            pointRadius: 3, // ポイント半径
            pointBorderWidth: 2, // ポイント枠線の幅

            // hover時ポイントマーカー設定
            hoverBorderColor: "orange", // マウスが乗った時のボーダーの色
            hoverBackgroundColor: "yellow", // マウスが乗った時のレイヤー色

            // データ設定
            label: I18n.t("company_standard_assessment"), // ラベル名
            data: Object.values(this.rateDetailObj)
          }
        ]
      };
      this.optioncollection = {
        responsive: true, // レスポンシブ変更対応
        maintainAspectRatio: true, // 拡大時の縦横比を維持
        animations: [
          {
            easing: "liner",
            duration: 30000 // アニメーションにかかる時間
          }
        ],
        scale: {
          ticks: {
            suggestedMax: 5.0, // チャートの目盛
            suggestedMin: 0.0,
            stepSize: 0.5,
            fontColor: "navy", // チャート目盛の色
            fontSize: 13 // チャート目盛のサイズ
          },
          angleLines: {
            display: true
          },
          pointLabels: {
            display: true,
            fontSize: 12, // レーダーチャートのラベルを変更
            fontColor: "navy"
          }
        },
        legend: {
          display: true,
          labels: {
            fontColor: "navy", // ラベルの色
            fontSize: 15
          }
        },
        tooltips: { // https://tenderfeel.xsrv.jp/javascript/4111/ 現行.verでのバグ対処 各要素のラベル内レート表示

          // https://misc.0o0o.org/chartjs-doc-ja/configuration/tooltip.html 外部カスタムツールチップ作成方法
          enabled: this.compareFlg,
          callbacks: {
            label(tooltipItem, data) {
              return `${data.datasets[tooltipItem.datasetIndex].label} : ${data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]}`;
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>

</style>
